define('modules/settings_form/settings_form_view',[
  'backbone',
  'jquery',
  '_',
  './settings_form_model',

  'modules/form/CreateField',
  'modules/form/convert-form-data',

  'text!./settings_form_template.html',
  'text!modules/form/form_section_template.html',

  'session'

], function (Backbone, $, _, SettingsFormModel,
             CreateField,
             convertFormData,
             settings_form_template, settings_form_section_template,
             session) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (options) {
      _.extend(this, options);
      this.subViews = [];

      this.formModel = new SettingsFormModel({id: session.get('location_id')});

      this.dataModel = new Backbone.Model();

      this.listenTo(this.formModel, 'change', function (model) {

        this.render();

        this.settingsModel = new SettingsFormModel({id: model.get('id')});

        Backbone.trigger('render:form');
        Backbone.trigger('render:form:settings_form');

        this.listenTo(this.dataModel, 'change', function (model) {
          Backbone.trigger('formDirty', true);
        }, this);

        this.listenTo(this.settingsModel, 'sync', function (model) {

          if (!model.get('error')) {
            Backbone.trigger('formDirty', false);
          }

          this.formModel.set(model.toJSON());

          this.showFormFeedback(model);
        }, this);

      }, this);

      this.formModel.fetch();

    },

    subViews: [],
    template: _.template(settings_form_template),
    section_template: _.template(settings_form_section_template),
    events: {
      'submit .settings-form': 'submitSettingsForm'
    },

    render: function () {
      var $sections_html = $('<div />');

      var Field = CreateField.extend();

      this.$el.html(this.template(this.formModel.toJSON()));

      this.formModel.get('sections').each(function (section) {
        var section_html = this.section_template(section.toJSON()),
          $section_html = $(section_html);

        var fields_html = [];

        section.get('fields').each(function (field) {

//TEMP: remove when API sends correct value
          if (field.get('type') === 'slider') {
            field.set('type', 'range');
          }
          var field_view = new Field({model: field, dataModel: this.dataModel});

          this.subViews.push(field_view);
          fields_html.push(field_view.$el);
        }, this);

        $section_html.find('.js-form-section-content').html(fields_html);


        $sections_html.append($section_html);

      }, this);

      this.$('.js-form-sections').html($sections_html);

      return this;
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },

    showFormFeedback: function (model) {
      if (model.get('error')) {
        this.$('.js-feedback').html('<div class="settings-form-feedback settings-form-feedback--error"><span class="icon-status-error"></span> ' + model.get('error_message') + '</div>');
      } else {
        this.$('.js-feedback').html('<div class="settings-form-feedback settings-form-feedback--ok"><span class="icon-status-success"></span> ' + _.t('settingsform.feedback.settings_saved') + '</div>');
      }
    },

    submitSettingsForm: function (e) {
      e.preventDefault();
      this.settingsModel.set(this.dataModel.toJSON());
      this.settingsModel.save();
    }

  });
  return View;
});

